import React from 'react';

import {useAiReviewUsageDetail} from 'src/modules/admin/ai-assist-usage/hooks/useAiReviewUsageDetail';
import {useUserFeedback} from 'src/modules/admin/ai-assist-usage/hooks/useUserFeedback';
import {FeedbackTable} from 'src/modules/admin/ai-assist-usage/views/feedback-table';
import {RunsTable} from 'src/modules/admin/ai-assist-usage/views/runs-table';

import {Group, Item} from '@pb/kit-component-group';
import {SlideBox} from '@pb/kit-component-slide-box';

import {slideBoxContent} from '../ai-assist-usage.module.styl';

type Props = {
    expanded: boolean,
    changeRequestId: number,
};

export const AiAssistUsageDetail = ({changeRequestId, expanded}: Props) => {
    const {assistDetails, isLoading} = useAiReviewUsageDetail(changeRequestId);
    const {userFeedback, isFeedbackLoading} = useUserFeedback({changeRequestId});

    return (
        <SlideBox shown={expanded} className={slideBoxContent}>
            <Group direction="v" className="pdy-m">
                <FeedbackTable isLoading={isFeedbackLoading} userFeedbacks={userFeedback}/>
                <Item className="pt-m">
                    <RunsTable isLoading={isLoading} aiReviewUsageDetailedInfo={assistDetails}/>
                </Item>
            </Group>
        </SlideBox>
    );
};
